import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import server from "./backend";
import Toasted from "vue-toasted";
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import VueSocketIO from 'vue-socket.io'
import SocketIO from "socket.io-client"

Vue.config.performance = true
Vue.use(CoreuiVue)

const ServerURL = "https://poc-gw.corryn.net/";

new Vue({
  el: '#app',
  router,
  store,
  server,
  icons,
  template: '<App/>',
  components: {
    App
  }
})

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyD8vswyC9F9G4rpJnpfpgZAwL4J0C-FhO4",
    libraries: "places"
  }
});

const options = {
  path: "/dracio",
  transports: ["websocket", "polling"]
}

Vue.use(
  new VueSocketIO({
    debug: true,
    connection: SocketIO('https://poc-ws.corryn.net/', options),
    vuex: {
      store,
      actionPrefix: "SOCKET_"
    }
  })
)

Vue.use(Toasted, {
  duration: 5000,
  //icon: "check",
  action: {
    text: "Close",
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    }
  }
})
